module.exports = __webpack_public_path__ + "../resources/images/surprised-8858b3f68f52235f5a9c8bcc97a8d540.svg";